import loadingGif from 'assets/images/loading-icon.gif'
import classes from './LoadingIcon.module.scss'

export default function LoadingIcon() {
  return (
    <div className={`loading-icon__wrapper ${classes['image-wrapper']}`}>
      <img className={classes['image']} src={loadingGif} alt="Lataa..." />
    </div>
  )
}